// src/components/ProtectedRoute.jsx
import { Box } from '@mui/material';
import Loading from 'components/Loading/Loading.js';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ROLES } from '../types/roles';

/**
 * Props:
 *   - allowedRoles: an array of role strings, e.g. ['s', 'd'] or [ROLES.super_admin.role, ROLES.distributor.role]
 *   - children: the component(s) you want to render if the user is allowed
 */
const ProtectedRoute = ({ allowedRoles = [], children }) => {
  const currentUser = useSelector(state => state.sensors.currentUser);

  // If no allowedRoles specified, allow all authenticated users
  if (allowedRoles.length === 0) {
    return children;
  }

  // Check if current user's role is in the allowed roles
  if (!allowedRoles.includes(currentUser.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
